<div class="activation-container">
  <img src="assets/svg/logo.svg" alt="Logo" class="activation-logo"/>
  <div class="activation-card">
    <div class="card-image-wrapper">
      <img src="assets/images/blue-card-hand.png" alt="Business Card" class="card-image"
           [ngClass]="{ 'card-image-mobile': isMobile }"
      />
    </div>
    <h2 class="activation-title">{{'business_card.title' | translate}}</h2>
    <p class="activation-description">
      {{'business_card.description' | translate}}
    </p>
    <button class="activate-btn" (click)="activateBusinessCard()">{{'business_card.btn_activate' | translate}}</button>
    <button class="cancel-btn" (click)="cancel()">{{'business_card.btn_cancel' | translate}}</button>
  </div>
</div>
